import { ConfigStateService } from '@abp/ng.core';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { NavService } from '../nav/shared/nav.service';
import { FormBuilder } from '@angular/forms';
import { WarenkorbsService } from '../warenkorbs/shared/warenkorbs.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';

@Component({
    selector: 'app-webshop-checkout',
    templateUrl: './checkout_new.component.html',
    styleUrls: ['./checkout_new.component.scss']
})
export class CheckoutComponent_new implements OnInit, AfterViewInit {
  
    // Utils
    isLoading: boolean = true;

    requesttype: number;

    selectedItem: any;  // Das ausgewählte Element aus der Combobox

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private navService: NavService,
        private oAuthService:OAuthService,
        private config: ConfigStateService,
        private warenkorbService:WarenkorbsService,
        private _formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<CheckoutComponent_new>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngAfterViewInit(): void {
       this.isLoading=false;       
    }

    ngOnInit(): void {

        this.requesttype = this.data.requesttype;
    
        this.warenkorbService.getRechnungsadresse().subscribe(x => {

            var adr = (x.anrede != null ? x.anrede + "<br>" : '');

            adr += ((x.vorname != null ? x.vorname : '') + ' ' + (x.nachname != null ? x.nachname : '')).trim();

            adr += "<br>" + (x.firmenname != null ? x.firmenname : '');
            adr += "<br>" + (x.strasse != null ? x.strasse : '');
            adr += "<br>" + (x.plz != null ? x.plz : '') + ' ' + (x.ort != null ? x.ort : '');

            document.getElementById("checkout_adr").innerHTML = adr;

        });

        this.warenkorbService.getAddresslist('', true).subscribe(x => {
            this.data = x;

            this.selectedItem = this.data[0].Id; //entspricht Rechnungsadresse
            this.onSelectadrChange(this.data[0].Id);
        });

        this.warenkorbService.getPaymentterm().subscribe(x => {
            document.getElementById("checkout_paymentterm").innerHTML = x["paymentterm"];
        });   

    }

    closeDialog(typ): void {
        const result = { type: typ, kennung: this.selectedItem };  // Liste mit mehreren Werten
        this.dialogRef.close(result);  // Gibt eine Liste mit mehreren Werten zurück
    }

    onSelectadrChange(kennung) {

        //in array die adresse finden
        const index = this.data.findIndex(item => item.Id === Number(kennung));

        if (index !== -1) {

            var x = this.data[index];

            var adr = (x.Anrede != null ? x.Anrede + "<br>" : '');

            adr += ((x.Vorname != null ? x.Vorname : '') + ' ' + (x.Nachname != null ? x.Nachname : '')).trim();

            adr += "<br>" + (x.Firmenname != null ? x.Firmenname : '');
            adr += "<br>" + (x.Strasse != null ? x.Strasse : '');
            adr += "<br>" + (x.Plz != null ? x.Plz : '') + ' ' + (x.Ort != null ? x.Ort : '');

            document.getElementById("delivery_adr").innerHTML = adr;
        }
    }

}